<template>
  <div class="project-app"> 
    <My-new-nav ref="header"></My-new-nav>
      <div class="project-info">
        <div class="project-item">
          <div class="product-img"><img class="img1" src="../../../assets/image/product/patient/project.png" alt="苁蓉-数字化运营平台"></div>
          <div class='flexColFirCen'>
            <div class="project-name margin-top-45">医智诺就医助手<span>小程序</span></div>
            <div class="product-description">「医智诺就医助手」小程序解决患者就医难题，问诊购药一站式服务，上万医生全天候服务，全方位健康管理和专属家庭医生服务，让生活更健康。</div>
          </div>
        </div>
        <div class="project-item bg-gray">
          <ecn-title title="搭建健康服务生态场景化平台"></ecn-title>
          <div class="model-item flexRowBetCen">
            <div class='flexColCen2 model-item-info'>
              <div class="project-name">无忧问诊购药服务</div>
              <div class="product-description">随时随地线上问诊，一键购药快速送达，满足全天问诊购药需求，上万医生在平台等您来。</div>
            </div>
            <div class="product-img"><img class="img2345 item-img1" src="../../../assets/image/product/patient/model1.png" alt="无忧问诊购药服务"></div>
          </div>
        </div>
        <div class="project-item">
          <div class="model-item flexRowBetCen">
            <div class="product-img"><img class="img2345 item-img2" src="../../../assets/image/product/patient/model2.png" alt="专属家庭医生服务"></div>
            <div class='flexColCen2 model-item-info'>
              <div class="project-name">专属家庭医生服务</div>
              <div class="product-description">为家庭提供医疗保健服务，满足每一个家庭的就诊购药、健康管理需求，守护您和家人的健康。</div>
            </div>
          </div>
        </div>
        <div class="project-item bg-gray">
          <div class="model-item flexRowBetCen">
            <div class='flexColCen2 model-item-info'>
              <div class="project-name">全周期健康管理服务</div>
              <div class="product-description">诊后全生命周期健康管理，线上线下一体化服务，随访定时健康提醒，科普文章视频随时学习。</div>
            </div>
            <div class="product-img"><img class="img2345 item-img3" src="../../../assets/image/product/patient/model3.png" alt="全周期健康管理服务"></div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name:'project-app-mobile',
    data(){
        return{
            
        }
    },
    mounted(){
       
    },
    methods: {
       
    } 
}
</script>

<style lang="scss" scoped>
  .flexColFirCen{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .flexColCen2{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .flexRowBetCen{
    display: flex;
    justify-content: space-between;
  }
  .project-app{
    // font-family: SourceHanSansCN-Regular;
    padding-top: 120px;
    div{
      box-sizing: border-box;
    }
    .margin-top-45{
      margin-top: 45px;
    }
    .project-item{
      width: 100%;
      padding: 120px 36px;
      &:first-child{
        padding-top: 0;
      }
    }
    .project-name{
      font-family: YouSheBiaoTiHei;
      color: #212121;
      line-height: 90px;
      margin-bottom: 33px;
      font-size: 90px;
      span{
        font-size: 51px;
      }
    }
    .product-description{
      font-weight: 400;
      font-size: 42px;
      color: #212121;
      // font-family: PingFangSC-Regular, PingFang SC;
      line-height: 72px;
      text-align: justify;
    }
    .product-img{
      display: flex;
      justify-content: center;
      width: 100%;
      img{
        display: block;
      }
      .img1{
        width: 78.46%;
        max-width: 798px;
        margin: 60px 0;
      }
      .img2345{
        width: 100%;
        max-width: 550px;
        margin-bottom: 60px;
      }
    }
    .model-item{
      .model-item-info{
        width: 50%;
        align-items: flex-start;
      }
      .project-name{
        font-size: 54px;
        line-height: 54px;
      }
      .product-img{
        width: calc(50% - 40px);
        .item-img1{
          width: 110%;
          max-width: 550px;
        }
        .item-img2{
          width: 90%;
          max-width: 470px;
        }
        .item-img3{
          width: 105%;
          max-width: 520px;
        }
      }
    }
    
    .ecn-title ::v-deep {
      margin-bottom: 120px;
      .title{
        font-size: 54px;
        line-height: 54px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        color: #333;
        letter-spacing: 3px;
      }
      .line{
        width: 84px;
        height: 18px;
        margin-top: 24px;
      }
    }
    .bg-gray{
      background-color: #F9F9FD;
    }
  }
</style>